import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    faBars,
    faTimes,
} from "@fortawesome/free-solid-svg-icons";
import SilverideaLogo from "../../Components/SilverideaLogo/SilverideaLogo";

const HeaderDark = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const navigate = useNavigate();

    const scrollToSection = (sectionId: string) => {
        const section = document.getElementById(sectionId);
        if (section) {
            const navbarHeight = 70; // Height of the navbar
            const sectionPosition = section.offsetTop - navbarHeight;
            window.scrollTo({
                top: sectionPosition,
                behavior: "smooth",
            });
            setMobileMenuOpen(false);
        }
    };

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return <nav className="freelancer-navbar">
        <div className="navbar-container">
            <div className="navbar-left">
                <SilverideaLogo />
            </div>
            <div className={`navbar-links ${mobileMenuOpen ? "active" : ""}`}>
                <button
                    className="navbar-link"
                    onClick={() => scrollToSection("features")}
                >
                    Features
                </button>
                <button
                    className="navbar-link"
                    onClick={() => scrollToSection("process")}
                >
                    Process
                </button>
                <button
                    className="navbar-link"
                    onClick={() => scrollToSection("projects")}
                >
                    Projects
                </button>
                <button
                    className="navbar-link"
                    onClick={() => scrollToSection("calculator")}
                >
                    Calculator
                </button>
                <button
                    className="navbar-link"
                    onClick={() => scrollToSection("qa")}
                >
                    Q&A
                </button>
                <button
                    className="navbar-link"
                    onClick={() => scrollToSection("contact")}
                >
                    Contact
                </button>
            </div>
            <button className="navbar-hamburger" onClick={toggleMobileMenu}>
                <FontAwesomeIcon icon={mobileMenuOpen ? faTimes : faBars} />
            </button>
        </div>
    </nav>;
};

export default HeaderDark;